import Increment from './Increment.jsx';

export default Increment;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/Filter/filters/Increment/index.js